import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { RegionService } from '../../services/region/region.service';
import { State } from '../../model/state.model';
import { StatesService } from '../../services/states/states.service';
import { StateRequirementService } from '../../services/state_requirements/staterequirements.service';
import { StateRequirement, PersonalPropertyEffects } from '../../model/staterequirements.model';
import { StateRequirementRepossessionComponent } from '../state-requirement-repossession/state-requirement-repossession.component';
import { StateRequirementPrerepossessionComponent } from '../state-requirement-prerepossession/state-requirement-prerepossession.component';
import { StateRequirementPostrepossessionComponent } from '../state-requirement-postrepossession/state-requirement-postrepossession.component';
import { StateRequirementStoragefeeComponent } from '../state-requirement-storagefee/state-requirement-storagefee.component';
import { StateRequirementPersonalpropertyComponent } from '../state-requirement-personalproperty/state-requirement-personalproperty.component';
import { StateRequirementPersonalproperty1Component } from '../state-requirement-personalproperty1/state-requirement-personalproperty1.component';

@Component({
  selector: 'app-staterequirements',
  templateUrl: './staterequirements.component.html',
  styleUrls: ['./staterequirements.component.css'],
})

export class StaterequirementsComponent implements OnInit {
  DocListErrMsg;
  DocListErr: boolean = false;
  states: State[] = [];
  allStates: State[] = [];
  stateRquirementFound: boolean = false;
  stateCode: string = '-1'; // -1 is a default value which will set the value to select a state
  stateRequirment: StateRequirement;
  submitSuccess = false;
  errorOccured = false;
  public role: string;
  clientDisable: any;
  clientHidden: any;
  submitHidden: any;
  public showFlag: boolean = false;
  public parClicked: any;
  public agentClicked: any;
  agentId: any;
  Disclaimer: any;
  @ViewChild(StateRequirementRepossessionComponent) stateRequirementRepossessionComponent;
  @ViewChild(StateRequirementPrerepossessionComponent) stateRequirementPrerepossessionComponent;
  @ViewChild(StateRequirementPostrepossessionComponent) stateRequirementPostrepossessionComponent;
  @ViewChild(StateRequirementStoragefeeComponent) stateRequirementStoragefeeComponent;
  @ViewChild(StateRequirementPersonalpropertyComponent) stateRequirementPersonalpropertyComponent;
  @ViewChild(StateRequirementPersonalproperty1Component) stateRequirementPersonalproperty1Component;
  message: string;
  constructor(private statesService: StatesService, private stateRequirementService: StateRequirementService) {
  }

  ngOnInit() {

    this.getAllStates()
    this.agentId = localStorage.getItem("AgentId");
    this.role = localStorage.getItem("Role");
    this.parClicked = localStorage.getItem("parClicked");
    this.agentClicked = localStorage.getItem("agentClicked");
    if (this.role === "PC PAR Vendor Relations" || this.role === "PC Client" && (this.agentClicked === "false" && this.parClicked === "false")) {
      this.getStatesByMasterVendorId(this.agentId);
      this.showFlag = true;
    }
    else if (this.role === "PC Client" && this.agentClicked === "true") {
      this.getStatesByMasterVendorId(this.agentId);
      this.showFlag = true;
    }
    else if (this.role === "PC Client" && this.parClicked === "true") {
      this.showFlag = false;
      this.getAllStates()
    }
    else if (this.role === "PC PAR Admin" && this.agentClicked === "true") {
      this.getStatesByMasterVendorId(this.agentId);
      this.showFlag = true;
    }
    else if (this.role === "PC PAR Admin" && this.parClicked === "true") {
      this.showFlag = false;
      this.getAllStates()
    }
    else {
      this.getAllStates()
      this.showFlag = false;
    }

    this.role = localStorage.getItem("Role");
    if (this.role === "PC PAR Vendor Relations" || this.role === "PC Client" || (this.role === "PC PAR Admin" && this.agentClicked === "true")) {
      this.submitHidden = true;
    } else {
      this.submitHidden = false;
    }
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
    }
  }

  // get all states
  getStatesByMasterVendorId(vendorId) {
    this.statesService.getStatesByMasterVendorId(vendorId).subscribe((lstStates) => {
      this.states = lstStates.States;
    }, err => {
      this.DocListErrMsg = "States in states requirements " + err;
      this.DocListErr = true;
    });
  }

  getAllStates() {
    this.statesService.getStates().subscribe((lstStates) => {
      this.allStates = lstStates.States;
    }, err => {
      this.DocListErrMsg = "States in states requirements " + err;
      this.DocListErr = true;
    });
  }
  // get the state requirement based on the state code.
  getStateRequirementByState() {
    this.errorOccured = false;
    this.submitSuccess = false;

    if (this.stateCode === '-1') {
      this.stateRequirment = new StateRequirement();
      this.stateRquirementFound = false;
      this.Disclaimer = '';
      return;
    }
    this.Disclaimer = 'This information is general in nature and references certain state-wide rules, procedures or requirements that PAR utilizes to assess the compliance of its recovery vendors. This information is provided for informational purposes only and is not intended to and should not be relied upon or construed as a legal interpretation or legal advice. This information may not be accurate, complete or up-to-date and PAR disclaims any duty to correct, complete or update any such information. You may not rely on this information for any purpose, nor may you copy, reproduce or distribute any of this information.';
    this.stateRequirementService.getStateRequirmentByStateCode(this.stateCode, this.agentId).subscribe(
      (stateRequirmentObj) => {
        if (stateRequirmentObj.Status == 200 && stateRequirmentObj.Details.length > 0) {
          this.stateRequirment = stateRequirmentObj.Details[0];
          this.DocListErr = false;
          this.stateRquirementFound = true;
        } else {
          this.stateRquirementFound = false;
          this.stateRequirment = null;
        }
      }, err => {
        this.DocListErrMsg = "State Requirements Data " + err;
        this.DocListErr = true;
      });
  }

  saveStateRequirements() {
    if (this.stateCode === '-1') {
      this.message = 'Please select state before submitting the infomation.';
      this.errorOccured = true;
      return;
    } else {
      this.errorOccured = false;
      this.message = '';
    }

    this.stateRequirment = new StateRequirement();
    this.stateRequirment.StateCode = this.stateCode;
    this.stateRequirment.VendorId = this.agentId;
    this.stateRequirment.RecoveryVendorCredentials = this.stateRequirementRepossessionComponent.repossessionAgent;
    this.stateRequirment.PreRepossession = this.stateRequirementPrerepossessionComponent.preRepossession;
    this.stateRequirment.PostRepossession = this.stateRequirementPostrepossessionComponent.postRepossession;
    this.stateRequirment.StorageFees = this.stateRequirementStoragefeeComponent.storageFees;

    if (this.stateRequirment.PersonalPropertyEffects == null ||
      typeof this.stateRequirment.PersonalPropertyEffects !== undefined) {
      this.stateRequirment.PersonalPropertyEffects = new PersonalPropertyEffects();
    }

    this.stateRequirment.PersonalPropertyEffects = this.stateRequirementPersonalpropertyComponent.personalPropertyEffects;
    this.stateRequirment.VehicleSaleDisposal = this.stateRequirementPersonalproperty1Component.personalPropertyEffects1;

    if (!this.stateRquirementFound) { this.CreateStateRequirementService(); } else {
      this.UpdateStateRequirementService();
    }
  }

  private UpdateStateRequirementService() {
    this.stateRequirementService.updateStateRequirements(this.stateRequirment).subscribe((stateRequirmentObj) => {
      this.message = 'State Requirements updated successfully.';
      this.submitSuccess = true;
      this.errorOccured = false;
    }, err => {
      this.DocListErrMsg = "State Requirements Updation " + err;
      this.DocListErr = true;

    });
  }

  private CreateStateRequirementService() {
    this.stateRequirementService.postStateRequirements(this.stateRequirment).subscribe((stateRequirmentObj) => {
      this.message = 'State Requirements saved successfully.';
      this.submitSuccess = true;
      this.errorOccured = false;
    }, err => {
      this.DocListErrMsg = "State Requirements Creation " + err;
      this.DocListErr = true;
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/components/staterequirements/staterequirements.component.ts